import { useRef } from 'react';
import { KickstarterButton } from '../../ui/KickstarterButton';
import DashboardPreviewImage from '../../../assets/DashboardPreview.png';
import BackgroundImage from '../../../assets/HeroBackground.png';
import './styles.css';

export function Hero() {
  const buttonRef = useRef(null);

  const handleMouseMove = (e) => {
    const btn = buttonRef.current;
    if (!btn) return;

    const rect = btn.getBoundingClientRect();
    const btnX = rect.left + rect.width / 2;
    const btnY = rect.top + rect.height / 2;
    const deltaX = e.clientX - btnX;
    const deltaY = e.clientY - btnY;
    const strength = 0.008;

    btn.style.transform = `
      translate(${deltaX * strength}px, ${deltaY * strength}px)
    `;
  };

  const handleMouseLeave = () => {
    const btn = buttonRef.current;
    if (!btn) return;

    btn.style.transform = `translate(0px, 0px)`;
  };

  return (
    <section
      id="top"
      className="hero"
      style={{ backgroundImage: `url(${BackgroundImage})` }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className="heroBg" aria-hidden="true" />
      <div className="container heroStack">
        <div className="heroCopy">
          <h1 className="heroTitle">
            Collaborate Beyond <span className="accent">Borders</span>
          </h1>
          <p className="heroSubtitle">
            Connect with students from universities across Europe, build international teams, and work on real projects
            without physical mobility.
          </p>
          <div className="heroActions">
            <KickstarterButton
              ref={buttonRef}
              className="kickstarterButton"
              href="https://www.kickstarter.com/projects/tymurlatush/daocampus"
            />
          </div>
        </div>
        <div className="heroMock">
          <img
            src={DashboardPreviewImage}
            alt="Dashboard Preview"
            className="DashboardPreview"
          />
        </div>
      </div>
    </section>
  );
}
